import { $qs, $qsa } from '../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';

gsap.registerPlugin(ScrollTrigger);



function video() {
    const section = $qs('[data-name="banner"]');
    const video = $qs('[data-target="video"]', section);
    const videoTitle = $qs('[data-target="video-title"]', section);

    gsap.to(video, {
        scrollTrigger: {
            trigger: section,
            scrub: true,
            start: 'center bottom',
            end: 'bottom bottom',
            onEnterBack: () => {
                videoTitle.dataset.state = 'hidden';
            },
            // markers: true
        },
        scale: 1,
        ease: 'none',
        transformOrigin: 'top center',
        onComplete: () => {
            videoTitle.dataset.state = 'visible';
        }
    });
}

function AdmissionsOverview() {
    if (!$qs('.page-template-tpl-admissions-overview')) return;
    
    video();
}

export default AdmissionsOverview;